import { h } from 'preact'
import Switcher from '../control/Switcher'
import InputAddon from '../control/InputAddon'

export interface QuickLinksSettingsType {
  borderRadius: number
  enableBorder: boolean
}

interface Props {
  settings: QuickLinksSettingsType
  onChange: (newData: Partial<QuickLinksSettingsType>) => void
}

const QuickLinksSettings = (props: Props) => <div className='form-group row'>
  <div className='col-md-3 qa-quicklinks-border-radius'>
    <div className='quick_links_common_settings_title'>Border radius</div>
    <InputAddon type='number' addon='px' value={props.settings.borderRadius} min={0} onChange={(val: string) => props.onChange({ borderRadius: parseInt(val, 10) })} />
  </div>
  <div className='col-md-3 qa-quicklinks-border'>
    <div className='quick_links_common_settings_title'>Border</div>
    <Switcher on={props.settings.enableBorder} onChange={() => props.onChange({ enableBorder: !props.settings.enableBorder })} />
  </div>
</div>

export default QuickLinksSettings
